import { IconButton, InputAdornment } from "@material-ui/core";

import DateRangeIcon from "@material-ui/icons/DateRange";

export default function MeditocDateIcon() {
    return (
        <InputAdornment position="end">
            <IconButton>
                <DateRangeIcon />
            </IconButton>
        </InputAdornment>
    );
}
